/* eslint-disable consistent-return,@typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { canUseDOM } from '@/app/common/utils/canUseDOM';

type UseOnScreen = {
  ref: any;
  defaultValue?: boolean;
  options?: any;
};

const useOnScreen = ({ ref, defaultValue, options = {} }: UseOnScreen) => {
  const [isVisible, setIntersecting] = useState<boolean>(defaultValue || false);

  let observer: any;

  if (canUseDOM && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), options);
  }

  useEffect(() => {
    if (!canUseDOM && 'IntersectionObserver' in window) return;

    if (observer && ref.current) observer.observe(ref.current);
    // Remove the observer as soon as the component is unmounted
    return () => {
      observer?.disconnect();
    };
  }, []);

  return { isVisible };
};

export default useOnScreen;
